import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { filter, map, takeWhile, tap } from 'rxjs/operators';
import * as fromCommon from '../../../shared';
import * as fromShared from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromAccounts from '../../store';
import { AccountContract } from '../../store/account-contract.model';
import { Account } from '../../store/account.model';
import * as reducer from '../store/account-allocation.reducer';
@Component({
    selector: 'ef-account-allocations-container',
    templateUrl: './account-allocations-container.component.html',
    styleUrls: ['./account-allocations-container.component.scss'],
    standalone: false
})
export class AccountAllocationsContainerComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @Input() selectedError: fromCommon.IStatusMessage;
    process$: Observable<fromShared.Process>;
    accounts$: Observable<Account[]>;
    contracts$: Observable<AccountContract[]>;
    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    active = true;
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    constructor(
        private log: LoggingService,
        private store: Store<reducer.State>
    ) {}

    ngOnInit() {
        this.setupObservables();
        this.store.dispatch(fromAccounts.getAccounts({ AccountType: '' }));
        this.store.dispatch(fromAccounts.getContractARAccounts());
    }
    ngAfterViewInit() {
        this.setupSubscriptions();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.accounts$ = this.store.pipe(select(fromAccounts.selectAll));
        this.contracts$ = this.store.pipe(
            select(fromAccounts.selectContractARAccounts),
            map(x => clone(x))
        );
        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors),
            tap(selected =>
                this.log.verbose({
                    type: 'AccountAllocationsContainerComponent:selectedError$',
                    selected
                })
            )
        );
        const errors$ = this.store.pipe(select(fromShared.Errors.getErrors));
        this.selectedErrorWithStatus$ = combineLatest([
            this.selectedError$,
            errors$,
            this.accounts$.pipe(filter(x => !!x))
        ]).pipe(
            tap(([selected, errors]) =>
                this.log.verbose({
                    type: 'AccountAllocationsContainerComponent:errors$',
                    errors,
                    selected
                })
            ),
            map(
                ([selected, errors]) =>
                    errors.filter(
                        e =>
                            e.MsgEntityID === selected.MsgEntityID &&
                            e.MsgProcessID === selected.MsgProcessID
                    )[0]
            ),
            tap(selected =>
                this.log.verbose({
                    type: 'AccountAllocationsContainerComponent:errors$:filtered',
                    selected
                })
            )
        );
        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
    }
    setupSubscriptions() {}
    onShowError(event) {
        this.ShowErrorSubject.next(event);
    }
}
